import { Pressable, Text, View } from 'react-native'
import { PurchasesPackage } from 'react-native-purchases'

import { colors } from '../../../theme'
import { body2 } from '../../../theme/typography'

interface PurchasePlanOptionProps {
  pkg: PurchasesPackage
  isCompactLayout?: boolean
  isSelected: boolean
  onSelect: (pkg: PurchasesPackage) => void
  formatCurrency: (value: number, currencyCode: string) => string
  monthlyLabel: string
  yearlyLabel: string
  periodMonthLabel: string
  periodYearLabel: string
  yearlySavingsText: string | null
}

export function PurchasePlanOption({
  pkg,
  isCompactLayout = false,
  isSelected,
  onSelect,
  formatCurrency,
  monthlyLabel,
  yearlyLabel,
  periodMonthLabel,
  periodYearLabel,
  yearlySavingsText,
}: PurchasePlanOptionProps) {
  const isYearly = pkg.packageType === 'ANNUAL'
  const testId = isYearly
    ? 'e2e-purchase-package-yearly'
    : 'e2e-purchase-package-monthly'

  return (
    <Pressable
      onPress={() => onSelect(pkg)}
      className={`flex-row items-center ${isCompactLayout ? 'mb-2' : 'mb-4'}`}
      testID={testId}
    >
      <View
        className={`w-5 h-5 rounded-full border items-center justify-center mr-3 ${isSelected ? 'border-primary' : 'border-gray-300'}`}
      >
        {isSelected && <View className="w-2.5 h-2.5 rounded-full bg-primary" />}
      </View>
      <Text className="flex-1" style={[body2, { color: colors.ink }]}>
        {isYearly ? yearlyLabel : monthlyLabel} -{' '}
        {formatCurrency(pkg.product.price, pkg.product.currencyCode)}/
        {isYearly ? periodYearLabel : periodMonthLabel}
        {isYearly && yearlySavingsText != null && (
          <Text style={[body2, { color: colors.muted }]}>
            {' '}
            {yearlySavingsText}
          </Text>
        )}
      </Text>
    </Pressable>
  )
}
